import React, { useState, useEffect, useRef } from "react";
import "../css/discountModal.css";

const DiscountModal = ({ product, onClose, onSave }) => {
  const [discountType, setDiscountType] = useState("percent");
  const [discountValue, setDiscountValue] = useState(0);

  const handleSave = () => {
    const productWithDiscount = {
      ...product,
      discount: discountValue,         // ✅ Store flat discount (not applied here)
      discountType: discountType       // ✅ Store type
    };
    onSave(productWithDiscount);
    onClose();
  };
  

  const inputRef = useRef();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSave();
      }
    };
  
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [discountValue, discountType]);
  

  return (
    <div className="discount-modal-overlay">
      <div className="discount-modal">
        <h3>Apply Discount</h3>

        <label>Discount Type:</label>
        <select value={discountType} onChange={(e) => setDiscountType(e.target.value)}>
          <option value="percent">Percentage (%)</option>
          <option value="cash">Cash ($)</option>
        </select>

        <label>Discount Value:</label>
        <input
  type="number"
  value={discountValue}
  onChange={(e) => setDiscountValue(parseFloat(e.target.value))}
  min="0"
  ref={inputRef}
/>

        <div className="discount-modal-actions">
          <button onClick={handleSave}>Apply</button>
          <button onClick={onClose} className="cancel-btn">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default DiscountModal;
